module.exports = __webpack_public_path__ + "static/img/20231220_02.0f8aadd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2023/20231220_02.png
// module id = +zLj
// module chunks = 0